import { ConfigurationType } from 'civil-status/constants/configuration-type';

export const withInterpreteCheck = (isDichiarante: boolean, configuration: string): boolean => {
  return (
    isDichiarante &&
    configuration !== ConfigurationType.BASENOINT &&
    configuration !== ConfigurationType.BASENOINTR &&
    configuration !== ConfigurationType.BASENOINTP &&
    configuration !== ConfigurationType.PERIC_CIV &&
    configuration !== ConfigurationType.RICH_UCOPF &&
    configuration !== ConfigurationType.NEOSNOINT &&
    configuration !== ConfigurationType.NEOSNOINTP
  );
};
